// Base stylesheet needed for every page
import './scss/app.scss';

// Lazy load page depended scripts and stylesheets method
const loadComponent = async name => {
    const {default: component} = await import(`./${name}.js`);

    return component();
}

// Import everything in directory method used for example for images
const importAll = (r) => r.keys().forEach(r);

// Include scripts foreach page
require('./scripts/literprice');
// require('./scripts/nav');
// require('./scripts/search');
// require('./scripts/footer');

// Include page depended scripts and styles example
if(document.querySelector('.js-page-homepage') !== null) {
    loadComponent('homepage');
} else if(document.querySelector('.js-page-productpage') !== null) {
    loadComponent('productpage');
} else if(document.querySelector('.js-page-collection') !== null) {
    loadComponent('collection');
} else if(document.querySelector('.js-page-list-collections') !== null) {
    loadComponent('list-collections');
} else if(document.querySelector('.js-page-cart') !== null) {
    loadComponent('cart');
}


let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

// Importing all images
const images = require.context('./images', true,  /\.(png|jpe?g|gif)$/);
importAll(images);
